import RegistrarInstitutionForm from './RegistrarInstitutionForm';
export default RegistrarInstitutionForm;
